/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SingleSource.vue?vue&type=template&id=e85ad436&scoped=true&"
import script from "./SingleSource.vue?vue&type=script&lang=js&"
export * from "./SingleSource.vue?vue&type=script&lang=js&"
import style0 from "./SingleSource.vue?vue&type=style&index=0&id=e85ad436&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85ad436",
  null
  
)

export default component.exports